export type { SegmentedControlOptionFields } from './segmented-control-option';
export { default } from './segmented-control-option';
